import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export type StringEnum = Record<string, string> | string[];

export class EnumFilter implements Filter<string> {
    constructor(public enumerator: StringEnum) {}

    async validate(fieldValue: string, otherFields: FieldValues): Promise<Array<ErrorType>> {
        const enumValues: string[] = Object.values(this.enumerator);
        if (!enumValues.includes(fieldValue)) {
            return [{ code: 'enum', expectedValues: enumValues }];
        }
        return [];
    }
}
